import React from 'react';
import Button from '../../../../components/shared/button';

import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';

function ActiveBlock({ price, summary, handleClick, isBought, isFree, canActivate, btnUrl }) {

  const { t: trans } = useTranslation();

  return (
    <Card>
      <Card.Body>
        {
          isFree ?
            <>
              <p className='price'>{trans('detail.purchase.price')}</p>
              <p className='type'>{trans('result.per-company')}</p>
              <p className='text-center'>
                {trans('detail.purchase.free-use')}
              </p>
              <p className="free-for-use">
                <span className='note'>
                  {trans('detail.purchase.note')}
                </span>
                {trans('detail.purchase.note-text')}
              </p>
            </>
            :
            <>
              <p className='price'>{price}</p>
              {/* <Badge pill className="info-badge" variant="primary">{price} <span className='type'></span> </Badge> */}
              <p className='type'>{trans('result.per-company')}</p>
              <p className='text-center'>
                {summary ? summary : <p>{trans('common-action.content-not-found')}</p>}
              </p>
            </>
        }



        {
          canActivate ?
            !isBought ?
              <Button text={trans('detail.active')} classes="round activate" handleClick={handleClick}></Button>
              :
              <label className="activated">{trans('detail.activated')}</label>
            :
            <a target="_blank" rel="noopener noreferrer" className="btn-ue more" href={btnUrl}>{trans('result.more')}</a>
        }
      </Card.Body>
    </Card>
  );
}

export default ActiveBlock;